import { getSiteId, setSiteId } from "@/utils/cookie";
import { getLoginUserInfo, getMenuListByUser } from "@/api/login";
import { Storage } from "@/utils/storage";
import router from "@/router/index";
import getRoutes from "@/router/filterRoutes";
import { showError } from "@/utils/index";
import dynamicRoutes from "@/router/dynamicRoutes";
const state = {
  toggleNoticeDrawer: false, //开关消息中心面板
  unreadMsgCount: {}, //未读消息数量
  noticeActiveType: "", //消息中心当前选中的类型
  userPageActive: {},
  site: {
    id: getSiteId()
  },
  userInfo: {},
  menuCollapse: false, //是否折叠左侧菜单
  themeType: Storage.get("fm-theme-type", 1), // 1 暗黑模式 2 明亮模式
  menus: getRoutes(Storage.get("fm-menu")) //当前用户权限菜单
};

const mutations = {
  TOGGLE_NOTICE_DRAWER: (state, bool) => {
    //开关消息中心面板
    state.toggleNoticeDrawer = bool;
  },
  SET_NOTICE_ACTIVE_TYPE: (state, type) => {
    //设置当前选中消息类型
    state.noticeActiveType = type;
  },
  SET_UNREAD_MSG_COUNT: (state, obj) => {
    //设置未读消息数量
    state.unreadMsgCount = obj;
  },
  SET_USER_PAGE_ACTIVE: (state, e) => {
    state.userPageActive = e;
  },
  SET_SITE: (state, site) => {
    state.site = site;
    setSiteId(site.id);
    Storage.set(`fm-site${state.userInfo.userId}`, {
      userId: state.userInfo.userId,
      site
    });
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_USER_MENU: (state, menus) => {
    state.menus = menus;
  },
  SET_MENU_COLLAPSE_STATUS: (state, bool) => {
    state.menuCollapse = bool;
  },
  SET_THEME_TYPE: (state, num) => {
    state.themeType = num;
    Storage.set("fm-theme-type", num);
  }
};

const actions = {
  setSite({ commit }, data) {
    //设置站点数据
    let cachedSite = Storage.get(`fm-site${data.userId}`);
    if (cachedSite) {
      //如果有缓存站点
      let site = data.sites.find(e => e.id == cachedSite.site.id);
      if (site) {
        //如果缓存站点存在于当前用户所有站点下面
        commit("SET_SITE", site);
      } else {
        //否则使用当前用户所有站点的第一个站点
        commit("SET_SITE", data.sites[0]);
      }
    } else {
      let site = data.sites && data.sites[0];
      if (site) {
        commit("SET_SITE", site);
      }
    }
  },
  async getUserInfo({ commit, dispatch }, params) {
    //获取用户数据
    let data = await getLoginUserInfo(params);
    if (!data) {
      data = {};
    }
    data.userIds = [data.storeId, data.storeGroupId, data.userId].filter(
      item => item
    );
    commit("SET_USER_INFO", data); //设置用户数据
    dispatch("setSite", data); //设置站点
    return Promise.resolve(data);
  },
  async getUserMenu({ commit }) {
    //获取用户权限菜单
    let res = await getMenuListByUser();
    if (!res) {
      return;
    }
    if (Array.isArray(res) && res.length) {
      let menus = null;
      if (
        (location.host.includes("localhost") ||
          location.host.includes("10.150")) &&
        window.USE_LOCAL_MENUS
      ) {
        menus = getRoutes(dynamicRoutes);
      } else {
        menus = getRoutes(res); //传入菜单跟业务范围数据
      }
      Storage.set("fm-menu", menus);
      commit("SET_USER_MENU", menus);
      router.$addRoutes(menus);
      return Promise.resolve(menus);
    } else {
      showError("该用户没有访问权限");
    }
  },
  getBtnPermissionFrom(pagePath) {
    /**
     * 获取指定页面的按钮权限
     * @String pagePath: 页面路径 需要从该页面获取按钮权限数据
     **/
    let result = [];
    let findRoute = menus => {
      //找到需要获取按钮权限的路由
      for (let item of menus) {
        if (item.path != pagePath) {
          if (item.children && item.children.length) {
            findRoute(item.children);
          }
        } else {
          if (item.children && item.children.length) {
            result = findBtn(item.children);
          } else {
            //如果没有子级了 直接返回该路由的按钮权限
            result = item.meta.btn;
          }
        }
      }
    };
    let findBtn = children => {
      //找到需要获取的按钮权限数组
      for (let item of children) {
        if (item.path == pagePath) {
          //如果存在相同路径
          if (item.children && item.children.length) {
            findBtn(item.children);
          } else {
            //返回按钮
            return item.meta.btn;
          }
        } else {
          //返回按钮
          return item.meta.btn;
        }
      }
    };
    findRoute(state.menus);
    return result;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
